import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

const twMergeCustom = extendTailwindMerge({
  prefix: 'tw-',
})

export function cn(...inputs: ClassValue[]) {
  return twMergeCustom(clsx(inputs))
}
